export default "__VITE_ASSET__D3FwOsfP__"